import {
  CLAIM_WORK_FORM_LOADING,
  CLAIM_WORK_FORM_FAILED,
  CLAIM_WORK_DATA,
  CLAIM_WORK_TIMELINE_LOADING,
  CLAIM_WORK_TIMELINE_DATA,
  CLAIM_WORK_TIMELINE_FAILED,
  CLAIM_WORK_TIMELINE_CLEAR,
  CLAIM_WORK_TIMELINE_ADD_ITEM,
  CLAIM_WORK_TIMELINE_UPDATE_ITEM,
  CLAIM_WORK_TIMELINE_DELETE_ITEM,
  CLEAR_CLAIM_WORK_DATA,
  CLAIM_WORK_FORM_ID_UPDATE,
  CLAIM_WORK_FORM_ALERT,
} from './actions'
import { IClaimWorkState } from './interfaces'
import { ActivityItems, ActivityUpdateItem } from '../../components/v2/activity-timeline'
import { setTimelineItem } from '../../components/v2/activity-timeline/services/setTimelineItem'
import { updateTimelineItemByIndex } from '../../components/v2/activity-timeline/services/updateTimelineItemByIndex'
import { deleteTimelineItem } from '../../components/v2/activity-timeline/services/deleteTimelineItem'
import { updateTimelineItemByItemId } from '../../components/v2/activity-timeline/services/updateTimelineItemByItemId'

const initialState: IClaimWorkState = {
  parent_id: undefined,
  form: {
    id: undefined,
    current_stage: undefined,
    data: null,
    redirectUrl: undefined,
    isLoading: false,
    error: '',
    alert: null,
  },
  stages: {
    items: undefined,
    current: undefined,
    history: undefined,
  },
  timeline: {
    isLoading: false,
    error: '',
    data: {
      items: [],
      itemsDates: [],
      total: undefined,
      offset: undefined,
      page: undefined,
      limit: undefined,
    },
  },
}

export const claimWorkReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CLEAR_CLAIM_WORK_DATA:
      return initialState
    case CLAIM_WORK_FORM_LOADING:
      return {
        ...state,
        id: null,
        form: {
          ...state['form'],
          isLoading: true,
          data: null,
          error: '',
        },
      }
    case CLAIM_WORK_DATA:
      return {
        ...state,
        parent_id: payload?.parent_id,
        stages: payload.stages,
        form: {
          ...state['form'],
          isLoading: false,
          data: payload.data,
          id: payload.id,
          redirectUrl: payload?.redirectUrl,
          error: '',
        },
      }
    case CLAIM_WORK_FORM_FAILED:
      return {
        ...state,
        form: {
          ...state['form'],
          isLoading: false,
          error: payload,
        },
      }
    case CLAIM_WORK_FORM_ALERT:
      return {
        ...state,
        form: {
          ...state['form'],
          isLoading: false,
          alert: payload,
        },
      }
    case CLAIM_WORK_FORM_ID_UPDATE:
      return {
        ...state,
        form: {
          ...state['form'],
          id: payload,
        },
      }
    case CLAIM_WORK_TIMELINE_LOADING:
      return {
        ...state,
        timeline: {
          isLoading: true,
          error: '',
          data: {
            items: [],
            itemsDates: [],
            total: undefined,
            offset: undefined,
            page: undefined,
            limit: undefined,
          },
        },
      }
    case CLAIM_WORK_TIMELINE_DATA:
      return {
        ...state,
        timeline: {
          isLoading: false,
          error: '',
          data: payload,
        },
      }
    case CLAIM_WORK_TIMELINE_FAILED:
      return {
        ...state,
        timeline: {
          ...state['timeline'],
          isLoading: false,
          error: payload,
          data: {
            items: [],
            itemsDates: [],
            total: undefined,
            offset: undefined,
            page: undefined,
            limit: undefined,
          },
        },
      }
    case CLAIM_WORK_TIMELINE_CLEAR:
      return {
        ...state,
        timeline: {
          isLoading: false,
          error: '',
          data: {
            items: [],
            itemsDates: [],
            total: undefined,
            offset: undefined,
            page: undefined,
            limit: undefined,
          },
        },
      }
    case CLAIM_WORK_TIMELINE_ADD_ITEM: {
      const newActivityItems = payload as ActivityItems[]
      const timelineItems: ActivityItems[] = state.timeline.data?.items || []
      const timelineDaysItems = state.timeline.data?.itemsDates || []

      if (!newActivityItems.length) {
        return state
      }

      const { timelineItems: timelineItemsMod, timelineDates: timelineDaysItemsMod } =
        setTimelineItem(newActivityItems, timelineItems, timelineDaysItems)

      return {
        ...state,
        timeline: {
          ...state.timeline,
          data: {
            ...state.timeline.data,
            items: [...timelineItemsMod],
            itemsDates: [...timelineDaysItemsMod],
          },
        },
      }
    }
    case CLAIM_WORK_TIMELINE_UPDATE_ITEM: {
      const newDataItem = payload as ActivityUpdateItem
      const timelineItems: ActivityItems[] = state.timeline.data?.items || []
      const timelineDaysItems = state.timeline.data?.itemsDates || []
      const timelineItemsMod =
        newDataItem?.index || newDataItem?.index === 0
          ? updateTimelineItemByIndex(newDataItem, timelineItems, timelineDaysItems)
          : updateTimelineItemByItemId(newDataItem, timelineItems, timelineDaysItems)

      return {
        ...state,
        timeline: {
          ...state.timeline,
          data: {
            ...state.timeline.data,
            items: [...timelineItemsMod],
          },
        },
      }
    }
    case CLAIM_WORK_TIMELINE_DELETE_ITEM: {
      const deletedItem = payload as ActivityUpdateItem
      const timelineItems: ActivityItems[] = state.timeline.data?.items || []
      const timelineDaysItems = state.timeline.data?.itemsDates || []

      const { timelineItems: timelineItemsMod, timelineDates: timelineDaysItemsMod } =
        deleteTimelineItem(deletedItem, timelineItems, timelineDaysItems)

      return {
        ...state,
        timeline: {
          ...state.timeline,
          data: {
            ...state.timeline.data,
            items: [...timelineItemsMod],
            itemsDates: [...timelineDaysItemsMod],
          },
        },
      }
    }
    default:
      return state
  }
}
